<div
  #container
  class="image-card"
  cdkDrag
  (cdkDragReleased)="dragReleased.emit()"
  [cdkDragBoundary]="dragBoundary()"
  [ngStyle]="styles()">
  <div
    class="image-container"
    [style.padding.px]="imageContainerPadding()">
    <img [src]="imageSrc()" />
  </div>
</div>
